module.exports = __webpack_public_path__ + "assets/certificate_pdf/C Language Today_Silicon Stone Education_20180718.209cf2bc.pdf";